import { Component, Input } from '@angular/core';
import { Customer } from 'gung-standard';

@Component({
  selector: 'gung-jeeves-jeeves-customer-details-billing-tab',
  templateUrl: './jeeves-customer-details-billing-tab.component.html',
  styleUrl: './jeeves-customer-details-billing-tab.component.css',
  standalone: false
})
export class JeevesCustomerDetailsBillingTabComponent {
  @Input() customer: Customer;
}
